<template>
  <v-container>
    <v-row>
      <v-col>
        <h2
        style="font-family: esquare;font-size: 2em; color: white; font-variant: small-caps;">
          About me
        </h2>
        <p class="overline grey--text">
          i'm a full stack developer fluent in all things javascript.
        </p>
        <p class="overline grey--text">
          dedicated to creating optimal solutions. i work with clients to
          build a strategy to acheive their goals.
        </p>
        <p class="overline grey--text">
          my work spans from simple updates to existing sites, to creating custom web apps from scratch,
          i focus on finding out the goals of a client and working to make them happen in an optimal fashion.
        </p>
        <p class="overline grey--text">
          In my free time you can find me at home reading, programming, researching various emerging techs, and occasionally bingeing a new
          tv series. I also like to get outside, I'm often seen wandering the deep woods of the Ozarks. I enjoy spelunking, rock climbing, cycling, kayak/canoing, backpacking, trail running, and other various outdoor activities.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
	mounted() {
		window.scrollTo(0,0)
	}
}
</script>

<style scoped>

</style>